import { useEffect } from 'react'

export const usePasswordChangeRedirect = (
	signOutRedirectCallback: () => void,
	clearAuthStorage: () => Promise<void>
) => {
	useEffect(() => {
		const isLogoutRedirect = window.location.search.includes('pwd_updated=true')
		if (isLogoutRedirect) {
			clearAuthStorage().then(() => signOutRedirectCallback())
		}
	}, [signOutRedirectCallback, clearAuthStorage])
}
